import { HeaderWrapper } from 'layouts';
import { GivingTypeEnum, type PublicGivingContentObject } from 'models';
import { HandHeartLineIcon, HeaderAsset, HeaderContent } from 'ui';
import { images } from 'common/utils';
import { GiversCount } from '../components';
import { useGivingTypeOptions } from '../hooks';

type P = { givingContentObject: PublicGivingContentObject };

const PublicGivingHeader = ({ givingContentObject }: P) => {
  const { coverPhoto, endTime, giversCount, name, startTime, type } = givingContentObject.giving;
  const { getTranslate } = useGivingTypeOptions();

  const isParticipantsVisible = type === GivingTypeEnum.CROWDFUNDING || type === GivingTypeEnum.DONATION;
  return (
    <HeaderWrapper
      left={
        <HeaderAsset image={{ alt: 'Giving cover photo', src: coverPhoto?.url ?? images.default.givingCoverPhoto }} />
      }
      right={
        <HeaderContent
          tags={{
            children: getTranslate(type),
            color: 'orange',
            icon: <HandHeartLineIcon />,
          }}
          timeInfo={endTime ? { dateFrom: startTime, dateTo: endTime } : undefined}
          title={name}
        >
          {isParticipantsVisible ? <GiversCount count={giversCount} /> : null}
        </HeaderContent>
      }
    />
  );
};

export default PublicGivingHeader;
